export const environment = {
  production: true,
  apiUrl: 'https://mypt.com.tr/api',
  socketUrl: 'wss://mypt.com.tr',
  // Google Sign-In Web client ID (GCP project my-pt-497110). Public
  // value, not a secret. Authorized origins: mypt.com.tr + localhost:4200.
  googleClientId: '440892011971-tkve3b8r25fo5a8or2h0g79okcofqvk4.apps.googleusercontent.com',
  // Firebase Web app config (project: mypt-9bd61). Public client config,
  // not secrets — security comes from Authorized domains + Auth rules.
  // Phone provider must be enabled and mypt.com.tr added to Authorized
  // domains in the Firebase Console for SMS OTP to work.
  firebase: {
    apiKey: 'AIzaSyC-ttrmpEd9hlgwRwMh_cw1a6vL-erXTbw',
    authDomain: 'mypt-9bd61.firebaseapp.com',
    projectId: 'mypt-9bd61',
    appId: '1:21299180677:web:56c3cbd38d8e32110225ec',
  },
  // Google Search Console doğrulama değeri (meta google-site-verification).
  // Boşsa etiket basılmaz. Değeri kullanıcı verir (Task 14).
  googleSiteVerification: '',
};
